import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function ContactPage() {
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    sujet: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.nom || !formData.email || !formData.sujet || !formData.message) {
      setSubmitStatus('error');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('nom', formData.nom);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('sujet', formData.sujet);
      formDataToSend.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d44ii0upguuav66rgh6g', {
        method: 'POST',
        body: formDataToSend,
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nom: '',
          email: '',
          sujet: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const isFormValid = formData.nom && formData.email && formData.sujet && formData.message;

  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      
      <div className="pt-20 pb-24 px-4">
        <div className="max-w-md mx-auto">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold mb-2">Contact</h1>
            <p className="text-gray-400 text-sm">
              Une question ? Un projet ? Contactez-nous
            </p>
          </div>

          <form 
            onSubmit={handleSubmit} 
            className="space-y-8"
            data-readdy-form="contact-maison-zeus"
            id="contact-form"
          >
            <div>
              <label htmlFor="nom" className="block text-sm font-medium mb-2">
                Nom *
              </label>
              <input
                type="text"
                id="nom"
                name="nom"
                value={formData.nom}
                onChange={handleInputChange}
                className="w-full px-4 py-3 bg-gray-800 border border-gray-7

00 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-orange-500 transition-colors"
                placeholder="Votre nom complet"
                required
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium mb-2">
                Email *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-orange-500 transition-colors"
                placeholder="votre@email.com"
                required
              />
            </div>

            <div>
              <label htmlFor="sujet" className="block text-sm font-medium mb-2">
                Sujet *
              </label>
              <select
                id="sujet"
                name="sujet"
                value={formData.sujet}
                onChange={handleInputChange}
                className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:border-orange-500 transition-colors appearance-none"
                required
              >
                <option value="">Sélectionnez un sujet</option>
                <option value="Collaboration">Collaboration</option>
                <option value="Commande">Question sur une commande</option>
                <option value="Produit">Question sur un produit</option>
                <option value="Autre">Autre</option>
              </select>
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-medium mb-2">
                Message *
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                rows={5}
                maxLength={500}
                className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-orange-500 transition-colors resize-none"
                placeholder="Votre message..."
                required
              />
              <div className="text-right text-xs text-gray-400 mt-1">
                {formData.message.length}/500 caractères
              </div>
            </div>

            {submitStatus === 'success' && (
              <div className="p-4 bg-green-900/50 border border-green-500 rounded-lg text-green-400 text-sm">
                Message envoyé avec succès ! Nous vous répondrons rapidement.
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="p-4 bg-red-900/50 border border-red-500 rounded-lg text-red-400 text-sm">
                Erreur lors de l'envoi. Veuillez réessayer.
              </div>
            )}

            <button
              type="submit"
              disabled={!isFormValid || isSubmitting}
              className={`w-full py-3 px-6 rounded-lg font-medium transition-all ${
                isFormValid && !isSubmitting
                  ? 'bg-orange-500 hover:bg-orange-600 text-white'
                  : 'bg-gray-700 text-gray-400 cursor-not-allowed'
              }`}
            >
              {isSubmitting ? 'Envoi en cours...' : 'Envoyer le message'}
            </button>
          </form>

          <div className="mt-8 text-center">
            <div className="space-y-3 text-sm text-gray-400">
              <div className="flex items-center justify-center space-x-2">
                <i className="ri-mail-line"></i>
                <span>Adel@vybeparis.com</span>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <i className="ri-whatsapp-line"></i>
                <a href="https://wa.me/33658126340" target="_blank" rel="noopener noreferrer" className="hover:text-orange-500 transition-colors">
                  +33 6 58 12 63 40
                </a>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <i className="ri-instagram-line"></i>
                <span>@maison.zeus</span>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <i className="ri-map-pin-line"></i>
                <span>Paris, France</span>
              </div>
            </div>
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
}
